import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Script } from 'gatsby';

export const HatchChat = () => {
	const [showScript, setShowScript] = useState(null);

	const locations = useSelector((state) => state.locations);

	useEffect(() => {
		if (['754', '716'].includes(locations.showrooms?.[0]?.branch_id) || window.location.href.includes('/locations/ct/norwalk/') || window.location.href.includes('/locations/ny/roslyn-heights/')) {
			setShowScript('NY');
		} else if (['757', '731', '735'].includes(locations.showrooms?.[0]?.branch_id) || window.location.href.includes('/locations/nc/') || window.location.href.includes('/locations/north-carolina')) {
			setShowScript('NC');
		} else if (['743'].includes(locations.showrooms?.[0]?.branch_id) || window.location.href.includes('/where-to-buy/showrooms/grand-rapids-74301/')) {
			setShowScript('GR');
		} else {
			setShowScript(null);
		}
	}, [locations.showrooms]);

	useEffect(() => {
		if (!showScript) {
			const hatchChatElement = document.getElementsByTagName('hatch-chat')[0];
			const quiqChatElement = document.getElementById('quiq-chat-id');

			if (hatchChatElement) {
				hatchChatElement.remove();
			}

			if (quiqChatElement) {
				quiqChatElement.remove();
			}
		}
	}, [showScript]);

	if (!showScript) return null;

	return (
		<>
			{showScript === 'NC' && (
				<Script
					id='ncChat-script'
					key='ncChat'
					strategy='idle'
				>
					{`
						function _loadHatchScripts(t){try{var e=document,n=e.createElement("script");n.src=t,n.async=!0,n.defer=!0,n.dataset.hatchid="00000007";var a=e.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a)}catch(t){}}window.addEventListener("WebComponentsReady",function(){_loadHatchScripts("https://www.usehatchapp.com/hubfs/static/js/hatchChat-beta.js")}),"attachShadow"in Element.prototype?document.dispatchEvent(new CustomEvent("WebComponentsReady",{bubbles:!0})):_loadHatchScripts("https://unpkg.com/@webcomponents/webcomponentsjs@2.2.10/webcomponents-bundle.js");
					`}
				</Script>
			)}

			{showScript === 'GR' && (
				<Script
					id='grChat-script'
					key='grChat'
					strategy='idle'
				>
					{`
						function _loadHatchScripts(t){try{var e=document,n=e.createElement("script");n.src=t,n.async=!0,n.defer=!0,n.dataset.hatchid="00000018";var a=e.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a)}catch(t){}}window.addEventListener("WebComponentsReady",function(){_loadHatchScripts("https://www.usehatchapp.com/hubfs/static/js/hatchChat-beta.js")}),"attachShadow"in Element.prototype?document.dispatchEvent(new CustomEvent("WebComponentsReady",{bubbles:!0})):_loadHatchScripts("https://unpkg.com/@webcomponents/webcomponentsjs@2.2.10/webcomponents-bundle.js");
					`}
				</Script>
			)}

			{showScript === 'NY' && (
				<Script
					id='nyChat-script'
					key='nyChat'
					strategy='idle'
				>
					{`
						function _loadHatchScripts(t){try{var e=document,n=e.createElement("script");n.src=t,n.async=!0,n.defer=!0,n.dataset.hatchid="00000006";var a=e.getElementsByTagName("script")[0];a.parentNode.insertBefore(n,a)}catch(t){}}window.addEventListener("WebComponentsReady",function(){_loadHatchScripts("https://www.usehatchapp.com/hubfs/static/js/hatchChat-beta.js")}),"attachShadow"in Element.prototype?document.dispatchEvent(new CustomEvent("WebComponentsReady",{bubbles:!0})):_loadHatchScripts("https://unpkg.com/@webcomponents/webcomponentsjs@2.2.10/webcomponents-bundle.js");
					`}
				</Script>
			)}
			{showScript != null && (
				<style
					id='quiq-chat-id'
					dangerouslySetInnerHTML={{ __html: `.quiq-floating-element {display:none !important}` }}
				/>
			)}
		</>
	);
};
